<div class="pme-container">
    <div class="pme-new-row">
        <div class="purchase-info">
            <pme-purchase-info *ngIf="this.checkoutSuccessData" [invoice]="this.checkoutSuccessData.invoice"
                [bankBilletData]="this.checkoutSuccessData.bankBilletData" [pixData]="this.checkoutSuccessData.pixData"
                [creditCardData]="this.checkoutSuccessData.creditCardData"
                [contract]="this.checkoutSuccessData.contract" [finalBalanceTrust]="this.finalBalanceTrust"
                [balanceExpirationDate]="this.balanceExpirationDate"
                (onSuccessButtonClick)="this.onSuccessClick('primary')"></pme-purchase-info>
        </div>
        <div class="invoice">
            <pme-invoice *ngIf="this.checkoutSuccessData" [invoice]="this.checkoutSuccessData.invoice"
                [bankBilletData]="this.checkoutSuccessData.bankBilletData" [pixData]="this.checkoutSuccessData.pixData"
                [creditCardData]="this.checkoutSuccessData.creditCardData" [finalBalanceTrust]="this.finalBalanceTrust"
                [totalDebitTrust]="this.totalDebitTrust" [contract]="this.checkoutSuccessData.contract"
                [newPayment]="true" (onSuccessButtonClick)="this.onSuccessClick('primary')">
            </pme-invoice>
        </div>


    </div>
</div>